// extracted by mini-css-extract-plugin
export default {"agentBox":"AgentChatDashboardWidget_agentBox__36Uzc"};